import { cmpCookie } from "@foundation/cmp-client";
import { AdContextData } from "../type";
import { makeCachedGet } from "../util/requestHelpers";
import UserInfo from "../session/UserInfo";
import { Targeting, TargetingProvider } from "../interfaces/TargetingProvider";

export enum UserContentTargetingType {
    PERSONALIZATION = "personalization"
}

export class UserContentTargetingProvider implements TargetingProvider {

    private targetingUrl = `${ process.env.ADS_SERVICE_ENDPOINT }/ad-targeting/user-content`;
    private get: ReturnType<typeof makeCachedGet<Targeting>>;
    private timeoutInMs: number;
    private adContextData: AdContextData;
    private types: UserContentTargetingType[];
    private _userInfo: UserInfo;

    constructor(
        adContextData: AdContextData,
        targetingTypes: UserContentTargetingType[],
        userInfo: UserInfo,
        timeout:number = 5000
    ) {
        this.adContextData = adContextData;
        this.types = targetingTypes;
        this.get = makeCachedGet<Targeting>("UserContentTargeting");
        this._userInfo = userInfo;
        this.timeoutInMs = timeout;
    }

    private async buildUrl(): Promise<string> {
        const padAllowed = cmpCookie.padAllowed() ? "true" : "false";
        const sessionId = await this._userInfo.getSessionId();

        const slugParam = this.adContextData?.slug ? `&slug=${ encodeURIComponent(this.adContextData.slug) }` : "";
        const tickerIdParam = this.adContextData.tickerId ? `&ticker_id=${ encodeURIComponent(this.adContextData.tickerId) }` : "";
        const url = `${ this.targetingUrl }?targeting_types=${ this.types.join(",") }&session_id=${ sessionId }&consent=${ padAllowed }${ slugParam }${ tickerIdParam }`;

        return url;
    }

    async getTargeting(): Promise<Targeting> {
        if (this.types.length === 0) return Promise.resolve({});

        return this.get(await this.buildUrl(), this.timeoutInMs, {});
    }

}
